/**
 * Cuadradillo de 7: añade los adaptadores al carrito.
 *
 * El tema mete la manilla por su cuenta y avisa con `product:added`. Aquí se
 * escucha ese aviso y, si en ese formulario estaba marcado el cuadradillo de 7,
 * se añade un juego de adaptadores por cada manilla y se refresca el carrito
 * para que la línea aparezca al momento.
 *
 * El selector lo pinta snippets/product-cuadradillo.liquid, que solo sale en
 * las tiendas de Francia, Portugal y Alemania.
 */
(function () {
  'use strict';

  /** El bloque del cuadradillo que pertenece a este formulario. */
  function bloqueDe(form) {
    if (!form) return null;
    var dentro = form.querySelector('[data-cuadradillo]');
    if (dentro) return dentro;
    // El bloque podría quedar fuera del <form> si se recoloca desde el editor.
    return form.id ? document.querySelector('[data-cuadradillo][data-form-id="' + form.id + '"]') : null;
  }

  function eligioSiete(bloque) {
    var marcado = bloque && bloque.querySelector('input[type="radio"]:checked');
    return !!marcado && marcado.getAttribute('data-cuadradillo-valor') === '7';
  }

  function formDelBoton(boton) {
    if (!boton) return null;
    return boton.form || boton.closest('form');
  }

  async function añadirAdaptadores(bloque, cantidad) {
    var variante = parseInt(bloque.getAttribute('data-adaptador-variante'), 10);
    if (!variante || !cantidad || cantidad < 1) return;

    var propiedades = {};
    // Deja dicho a qué manilla acompaña: si el carrito lleva dos manillas
    // distintas con cuadradillo de 7, cada juego se ve por separado.
    var manilla = bloque.getAttribute('data-producto');
    if (manilla) propiedades[bloque.getAttribute('data-para-label') || 'Para'] = manilla;

    try {
      var res = await fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variante, quantity: cantidad, properties: propiedades }] })
      });
      if (!res.ok) {
        console.error('[cuadradillo] no se pudieron añadir los adaptadores:', res.status, await res.text());
        return;
      }
      // Que el mini-carrito y el contador se enteren de la línea nueva.
      document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {
      console.error('[cuadradillo] error al añadir los adaptadores:', e);
    }
  }

  document.addEventListener('product:added', function (event) {
    var detalle = event.detail || {};
    if (detalle.productAdded === false) return; // la manilla no llegó a entrar

    var bloque = bloqueDe(formDelBoton(detalle.button));
    if (!bloque || !eligioSiete(bloque)) return;

    var cantidad = parseInt(detalle.quantity, 10);
    añadirAdaptadores(bloque, isNaN(cantidad) ? 1 : cantidad);
  });

  /**
   * El pago rápido (Shop Pay, PayPal…) se salta el carrito, así que los
   * adaptadores no llegarían a entrar y la manilla saldría sin ellos. Mientras
   * esté elegido el cuadradillo de 7 se esconden esos botones y se compra por
   * el carrito de siempre.
   *
   * OJO: solo `.shopify-payment-button`. `.product-form__payment-container` es
   * el contenedor de TODO, «Añadir al carrito» incluido: esconderlo dejaba el
   * producto sin botón de comprar.
   */
  function pagoRapido(form) {
    if (!form) return [];
    return Array.prototype.slice.call(form.querySelectorAll('.shopify-payment-button'));
  }

  /**
   * La «i» de información: con el ratón basta el hover (lo hace el CSS), pero
   * en táctil hace falta el clic, así que aquí se alterna a mano.
   */
  document.addEventListener('click', function (event) {
    var boton = event.target.closest && event.target.closest('[data-cuadradillo-info-boton]');
    var abiertos = document.querySelectorAll('[data-cuadradillo-info].is-open');

    // Cerrar los que hubiera abiertos, salvo el que se acaba de pulsar.
    Array.prototype.forEach.call(abiertos, function (info) {
      if (boton && info.contains(boton)) return;
      info.classList.remove('is-open');
      var b = info.querySelector('[data-cuadradillo-info-boton]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });

    if (!boton) return;
    var info = boton.closest('[data-cuadradillo-info]');
    if (!info) return;
    var abierto = info.classList.toggle('is-open');
    boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cuadradillo-info].is-open'), function (info) {
      info.classList.remove('is-open');
      var b = info.querySelector('[data-cuadradillo-info-boton]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches || !radio.matches('[data-cuadradillo-valor]')) return;

    var bloque = radio.closest('[data-cuadradillo]');
    if (!bloque) return;

    var siete = eligioSiete(bloque);
    var nota = bloque.querySelector('[data-cuadradillo-note]');
    if (nota) nota.hidden = !siete;

    var form = bloque.closest('form') || (bloque.getAttribute('data-form-id')
      ? document.getElementById(bloque.getAttribute('data-form-id'))
      : null);
    pagoRapido(form).forEach(function (el) { el.hidden = siete; });
  });
})();
